import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useEditingMarriageClaimState } from "../state"

const ExportInformation: ReactiveComponent = () => {
	const state = useEditingMarriageClaimState()

	function renderExportInfo() {
		if (state.fullClaim.DateExported !== null) {
			return (
				<div class="d-flex gap-1">
					<h6>Date Last Exported:</h6>
					<h6 class="fw-bold">{state.fullClaim.DateExported.toGBDateTimeString()}</h6>
				</div>
			)
		}
		return <h5>No Exports</h5>
	}

	return () => (
		<>
			{state.allExports.length === 0 ? (
				<>{renderExportInfo()}</>
			) : (
				<div data-span="2">
					<table
						class={`table small table-striped table-hover grid-table grid-table-bordered`}
						style={{
							gridTemplateColumns: `max-content 1fr 1fr max-content`,
							padding: `1rem`,
						}}
					>
						<thead>
							<tr>
								<th>Id</th>
								<th>Form Type</th>
								<th>Stage Type</th>
								<th>Export Date</th>
							</tr>
						</thead>
						<tbody>
							{state.allExports.map((singleExport) => (
								<tr key={singleExport.Id}>
									<td class="d-flex align-items-center">{singleExport.Id}</td>
									<td class="d-flex align-items-center">{singleExport.FormType}</td>
									<td class="d-flex align-items-center">{singleExport.StageType ?? "Unknown"}</td>
									<td class="d-flex align-items-center">{singleExport.ExportDate.toGBDateTimeString}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
		</>
	)
}

export default defineComponent(ExportInformation)
